<template>
  <div class="fixed h-0">
    <audio ref="audioRef">
      <source :src="selectedAudioPath!" type="audio/ogg" />
      <source :src="selectedAudioPath!" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script setup lang="ts">
import { useEventBus } from '@/plugins/eventBus/eventBus';
import { onMounted, onUnmounted, ref } from 'vue';
import { EBeep } from './types';

const audioRef = ref<HTMLAudioElement | null>(null);

const selectedAudioPath = ref<string | null>(null);

const eventBus = useEventBus();

const playAudio = (audio: EBeep): void => {
  if (audioRef.value) {
    selectedAudioPath.value = `/sounds/${audio}`;
    audioRef.value.load();
    audioRef.value.play();
  }
};

onMounted(() => {
  eventBus.on('play-audio', playAudio);
});

onUnmounted(() => {
  eventBus.off('play-audio');
})
</script>